module.exports = __webpack_public_path__ + "static/media/comfort.ee671d82.svg";